import "./App.css";
import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Pages/store.js";
import { ToastContainer } from "react-toastify";
import ModalBox from "./Components/ModalBox.jsx";
import { ModalProvider, useModal } from "./Context/ModalContext.jsx";
import AuthGuard from "./Auth/authGuard.jsx";
import RouteFallback from "./Components/RouteFallback.jsx";
import RouteErrorBoundary from "./Components/RouteErrorBoundary.jsx";

const Login = lazy(() => import("./Pages/LoginPage"));
const SignUp = lazy(() => import("./Pages/SignUp"));
const SubmitImagesCompanyAdmin = lazy(() => import("./Pages/SubmitImagesCompanyAdmin.jsx"));
const AllAddedVehicles = lazy(() => import("./Pages/AllAddedVehicles.jsx"));
const ViewDetails = lazy(() => import("./Pages/ViewDetails.jsx"));
const ViewAcceptedDetails = lazy(() => import("./Pages/ViewAcceptedDetails.jsx"));
const FirstTimeLoginPage = lazy(() => import("./Pages/FirstTimeLoginPage.jsx"));
const IncomeEstimationPage = lazy(() => import("./Pages/IncomeEstimationPage.jsx"));
const DummyDetials = lazy(() => import("./Pages/DummyDetials.jsx"));
const AddNewVehicleDetails = lazy(() => import("./Pages/AddNewVehicleDetails.jsx"));
const PrivacyPolicy = lazy(() => import("./Pages/PrivacyPolicy.jsx"));
const DeleteAccountPage = lazy(() => import("./Pages/DeleteAccountPage.jsx"));
const ViewKYCDetails = lazy(() => import("./Pages/ViewKYCDetails.jsx"));
const HomePageCustomer = lazy(() => import("./Pages/HomePageCustomer.jsx"));
const VendorProfile = lazy(() => import("./Pages/VendorProfile.jsx"));

function App() {
  return (
    <div className="w-full min-h-screen bg-gray-100">
      <Provider store={store}>
        <ModalProvider>
          <Router>
            <ToastContainer />
            <RouteErrorBoundary>
              <Suspense fallback={<RouteFallback />}>
                <Routes>
                  <Route path="/SignUp" element={<SignUp />} />
                  <Route path="/" element={<Login />} />

                  <Route element={<AuthGuard />}>
                    <Route path="/Submit-images-vehicles" element={<SubmitImagesCompanyAdmin />} />
                    <Route path="/All-Added-Vehicles" element={<AllAddedVehicles />} />
                    <Route path="/view-details" element={<ViewDetails />} />
                    <Route path="/view-details-here" element={<ViewAcceptedDetails />} />
                    <Route path="/welcome-page" element={<FirstTimeLoginPage />} />
                    <Route path="/estimated-earnings" element={<IncomeEstimationPage />} />
                    <Route path="/dummy-details" element={<DummyDetials />} />
                    <Route path="/add-new-vehicle-details" element={<AddNewVehicleDetails />} />
                    <Route path="/View-KYC-Details" element={<ViewKYCDetails />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/delete-account" element={<DeleteAccountPage />} />
                    <Route path="/home-page-customer" element={<HomePageCustomer />} />
                    <Route path="/profile" element={<VendorProfile />} />
                  </Route>

                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Suspense>
            </RouteErrorBoundary>
          </Router>
          <GlobalModal />
        </ModalProvider>
      </Provider>
    </div>
  );
}

const GlobalModal = () => {
  const { modalData, closeModal } = useModal();
  return (
    <ModalBox
      isOpen={modalData.isOpen}
      title={modalData.title}
      body={modalData.body}
      iconType={modalData.iconType}
      onClose={closeModal}
      onAction={modalData.onAction}
      actionLabel={modalData.actionLabel}
    />
  );
};

export default App;
